import { nanoid } from 'nanoid';
import {
  IInit,
  MbXSharedData,
  MbXWrapperItems,
  MbXWrapRootOptions,
} from './types.mobx';

export const mobxWrappedItems = new Map<string, MbXSharedData<any, any>>();

const assignIdsToClassesRecursive = ({
  baseClass,
  id,
}: {
  baseClass: any;
  id: string;
}) => {
  if (!baseClass) {
    return;
  }

  const CLASSNAME = `mobx_id`;

  baseClass[CLASSNAME] = id;

  const fieldNames = Object.getOwnPropertyNames(baseClass);

  for (const field of fieldNames) {
    if (field === CLASSNAME) {
      return;
    }

    const currentField = baseClass[field];
    currentField[CLASSNAME] = id;

    if (
      currentField.constructor &&
      currentField.constructor.name !== 'Object' &&
      currentField.constructor.name !== 'Function'
    ) {
      assignIdsToClassesRecursive(currentField);
    }
  }
};

const createMobxRootWrapper = (wrapperItems: MbXWrapperItems) => {
  return <R extends IInit<RIP>, E, RCP, RIP>({
    RootStore,
    env,
    wrapperName,
    assignIdsToClasses = false,
    rootStoreInitParams,
    rootStoreConstructorParams,
  }: MbXWrapRootOptions<E, R, RCP, RIP>): R => {
    const id = nanoid();

    let instance: R;

    try {
      instance = new RootStore(rootStoreConstructorParams);
    } catch (e) {
      console.error(e);
      instance = RootStore as unknown as R;
    }

    const hasInit = 'init' in instance;
    const wrapperExists = wrapperName && wrapperItems.get(wrapperName);

    if (!hasInit && wrapperExists) {
      throw new Error(
        `Has init: ${hasInit} Wrapper name exists: ${wrapperExists}`,
      );
    }

    wrapperItems.set(wrapperName || id, {
      environmentData: env,
      root: instance,
    });

    instance.init(rootStoreInitParams);

    if (assignIdsToClasses) {
      assignIdsToClassesRecursive({
        baseClass: instance,
        id: wrapperName || id,
      });
    }

    return instance;
  };
};

export const initMobxWrappedRoot = createMobxRootWrapper(mobxWrappedItems);
